module.exports = __webpack_public_path__ + "img/CCS_logo_small.34854d67.png";